/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/** Telemetry constants for the Internal Ratings flow used by model-layer code. */
export const INTERNAL_RATINGS_DIAGNOSTIC_EVENT: string = "internal_ratings";

/** `internal_ratings` diagnostic discriminators. */
export const InternalRatingsEvent = {
  RatingsLoaded: "ratings_loaded",
  EmptyResponse: "empty_response",
  LookupFailed: "lookup_failed"
} as const;

export type InternalRatingsEventName =
  (typeof InternalRatingsEvent)[keyof typeof InternalRatingsEvent];
